module.exports = __webpack_public_path__ + "static/solutions_back-6f949464adb48d44317015f8b993af47.png";